import { createClient } from 'contentful';

export const client = (
  accessToken = process.env.NEXT_PUBLIC_CONTENTFUL_ACCESS_TOKEN!,
  host = 'cdn.contentful.com',
) =>
  createClient({
    accessToken: accessToken,
    space: process.env.NEXT_PUBLIC_CONTENTFUL_SPACE_ID!,
    environment: process.env.NEXT_PUBLIC_CONTENTFUL_ENVIRONMENT!,
    host: host,
  }).withoutUnresolvableLinks;

export const contentfulToPlainObject = (contentfulObject) => {
  return JSON.parse(JSON.stringify(contentfulObject));
};
